"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.settings.title': '打开设置',
    'shortcuts.settings.description': '打开设置面板以配置您的偏好',
};
